module.exports = __webpack_public_path__ + "assets/e79fad1760bf9cf542e482c095503dd0.svg";